import React from 'react';

import ConversationItem from '../conversationItem/index';
import './style.css';

function ConversationList({ deals, click, selected, selectedDealList }) {
  return (
    <div className="conversation-list">
      {deals
        ? deals.map((deal) => (
            <ConversationItem
              deal={deal}
              click={click}
              key={deal.id}
              active={selected.id === deal.id}
              selectedDealList={selectedDealList}
            />
          ))
        : ''}
    </div>
  );
}

export default ConversationList;
